import { useNavigate, useLocation } from 'react-router-dom';
import { entityPath, buildReturnTo } from '../components/Common/entityPaths';

/**
 * Custom hook for in-app navigation that avoids full page reloads.
 * Replaces window.location.href usage with React Router navigate().
 */
export function useAppNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Open an entity detail (see entityPaths.js). With returnLabel, the detail's BackButton
   * shows "← {returnLabel}" and returns to the current URL (e.g. the dashboard it was opened from).
   */
  const openEntity = (type, id, returnLabel) => {
    const path = entityPath(type, id);
    if (!path) return false;
    const returnTo = buildReturnTo({
      type, id, returnLabel, returnPath: `${location.pathname}${location.search}`,
    });
    navigate(path, { state: returnTo ? { returnTo } : undefined });
    return true;
  };

  return {
    goToSalesOrder: (id) => navigate(`/sales-orders/${id}`),
    goToSalesOrders: () => navigate('/sales-orders'),
    goToProductionOrder: (id) => navigate(`/production-orders/${id}`),
    goToProductionOrders: () => navigate('/production-orders'),
    goToQuote: (id) => navigate(`/quotes/${id}`),
    goToInventoryItem: (id) => navigate(`/inventory/items/${id}`),
    goHome: () => navigate('/home'),
    openEntity,
    navigate,
  };
}
